'use strict';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import {ITEMS_TYPES} from "@ispm/dynamic-form/constants/ItemsTypes";
import  { IspmHttpClient } from "@ispm/core/services/ispm-http-client";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {Subject} from "rxjs";
import {Form, FormGroup} from "@angular/forms";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import { NotificationMessageService } from "@ispm/core/components/customise-notification/notifications-message.service";
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import { StringUtils } from "@ispm/shared/utils/String.utils";
import {FileService} from "@ispm-client/modules/file-module/services/file.service";


@Component({
  selector: 'gen-IFU',
  templateUrl: './ifu-upload-details-modal.component.html',
  styleUrls: ['./ifu-upload-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('IFU')
export class IFUComponent implements OnInit, OnDestroy, IWidgetItem<any> {



  private _formConfig: Array<any>;

  public widgetData: any;
  public widgetPayload:any;
  public ifulanguages :any;
  public ifuApplications :any;
  public ifuApplication: any;
  public ifulanguage: any;
  public ifu:any;
  private destroyed$: Subject<any> = new Subject();
  private fileTypes: any;
  private temp: any;
  public inputConfig= [];
  public fileName= "No file chosen";
  widgetUpdateValueCallback: (value) => void;
  public listenToDataChange = true;

  constructor(private _ispmHttpClient: IspmHttpClient,
              private _isgHttpClient: HttpInterceptorService,
              private notificationMessageService: NotificationMessageService,
              private _changeDetector: ChangeDetectorRef,
              private _UserActionCreatorService: UserActionCreatorService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private fileService: FileService) {
  }


  public upload(files: File[]){
    if (files && files.length >0) {
      if (this.fileService.isForbiddenFileTypes(files[0].name, {pdf: this.fileTypes['pdf']})) {
        return;
      }

      if (StringUtils.isInvalidCharsInFileName(files[0].name)) {
        this.notificationMessageService.error(`${this.notificationMessage.FILENAME_CONTAINS_HTML}`);
        return;
      }
      this.ifu = files[0];
      this.fileName = this.ifu.name;
      this.widgetUpdateValueCallback(this.ifu);
    }
  }

  public submitIFU() {
   var fd = new FormData();
    fd.append('file', this.ifu);
    if (this.ifulanguage != null && this.ifu != null && this.ifuApplication != null) {
      let queryString = "lang=" + this.ifulanguage.code + "&AppId=" + this.ifuApplication.id;
      this._isgHttpClient.post('/reportsAndDocuments/uploadIfu?' + queryString, fd).subscribe(resdata => {
        this.notificationMessageService.success('IFU Uploaded Successfully');
        this._UserActionCreatorService.setReloadAdminWorklist(true);
      }, err => {   this.notificationMessageService.error('Unable to Upload IFU'); });
    }

  }

  set widgetConfig(widgetConfig) {

    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
    this.inputConfig.push(Object.assign(
      DynamicFormItem.builder(
        this._formConfig[0].label || '',
        this._formConfig[0].name,
        ITEMS_TYPES.DROPDOWN
      ).setCssClass("full-size-item form-item-column")
        .setAttributes(this._formConfig[0].attributes)
        .setRequired(this._formConfig[0].required), this._formConfig[0]

    ));
    this.inputConfig.push(Object.assign(
      DynamicFormItem.builder(
        this._formConfig[1].label || '',
        this._formConfig[1].name,
        ITEMS_TYPES.DROPDOWN
      ).setCssClass("full-size-item form-item-column")
        .setAttributes(this._formConfig[1].attributes)
        .setRequired(this._formConfig[1].required), this._formConfig[1]

    ));
}

  private _widgetFormInstanceSubmitted: boolean;


  public get widgetFormInstanceSubmitted(){
    return this._widgetFormInstanceSubmitted;
  }

 public  formupdate(form){
  this.ifuApplication = form.application;
  this.ifulanguage = form.language;
}

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean){
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
    this.submitIFU();
  };

  public widgetFormInstance: FormGroup;
  ngOnInit() {
    this.fileTypes = this.fileService.getUploadFileTypes();
 }


  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
}

  widgetValidator(): boolean {

    if(this.ifu != null){
      return  true;
    }else {
      return false;
    }
  }
}


